<template>
  <div id="app">
    <SiteHeader :isTransparent="isHeaderTransparent"/>
    <router-view></router-view>
    <SiteFooter/>
  </div>
</template>

<script>
import SiteHeader from '@/components/Header.vue'
import SiteFooter from '@/components/Footer.vue'

export default {
  name: 'App',
  components: {
    SiteHeader,
    SiteFooter
  },
  data() {
    return {
      isHeaderTransparent: false
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
}
</style>
